import { LegalLayout, useCompany, Mediator } from "./LegalLayout";

export default function MentionsLegales() {
  const COMPANY = useCompany();
  return (
    <LegalLayout title="Mentions légales" updated="septembre 2026" testid="mentions-legales-page">
      <p>Conformément aux articles 6-III et 19 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN), les informations suivantes sont portées à la connaissance des utilisateurs du site {COMPANY.site}.</p>

      <h2>1. Éditeur du site</h2>
      <ul>
        <li>Nom du site : {COMPANY.site}</li>
        <li>Éditeur et vendeur : {COMPANY.name}, exerçant sous le nom commercial {COMPANY.trade}</li>
        <li>Forme juridique : Entreprise individuelle</li>
        <li>Siège : {COMPANY.address}</li>
        <li>SIREN : {COMPANY.siren}</li>
        <li>Immatriculation : {COMPANY.rcs}</li>
        <li>N° TVA intracommunautaire : {COMPANY.vat}</li>
        <li>Adresse électronique : <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
        <li>Directeur de la publication : Robert CLERC</li>
      </ul>

      <h2>2. Hébergement</h2>
      <p>Le site est hébergé par : Emergent (plateforme d'hébergement) – coordonnées complètes : [à compléter].</p>

      <h2>3. Propriété intellectuelle</h2>
      <p>L'ensemble des éléments du site (textes, visuels, graphismes, logo, structure) est protégé par le droit de la propriété intellectuelle. Toute reproduction, représentation ou adaptation, totale ou partielle, sans autorisation écrite préalable de {COMPANY.name}, est interdite. Les marques Midea et PortaSplit appartiennent à leurs titulaires respectifs. Les visuels présentés sont des illustrations non contractuelles.</p>

      <h2>4. Responsabilité</h2>
      <p>{COMPANY.name} s'efforce d'assurer l'exactitude des informations diffusées sur le site, notamment les caractéristiques techniques communiquées par le fabricant. Il ne saurait toutefois être tenu responsable des erreurs, omissions ou d'une indisponibilité temporaire du site.</p>

      <h2>5. Données personnelles et cookies</h2>
      <p>Le traitement de vos données personnelles est décrit dans notre <a href="/politique-confidentialite">Politique de confidentialité</a>. Le site utilise des cookies strictement nécessaires et, uniquement avec votre consentement, le pixel Meta (mesure publicitaire, Meta Platforms Ireland Limited). Vous pouvez modifier votre choix à tout moment via le lien « Gérer les cookies » en bas de page.</p>

      <h2>6. Contact</h2>
      <p>Pour toute question, vous pouvez nous écrire à <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> ou par courrier à l'adresse du siège social.</p>

      <h2>7. Médiation de la consommation</h2>
      <Mediator email={COMPANY.email} />
    </LegalLayout>
  );
}
